// extracted by mini-css-extract-plugin
export default {"container":"Section_container__JJ5l-","header":"Section_header__yQTi6","title":"Section_title__Y5grN"};